<template>
  <div class="event-calendar">
    <b-container fluid>
      <b-row align-v="center">
        <b-col style="font-size: 1.5rem;">
          <b-button @click="changeMonth('prev')" size="sm" variant="primary" :disabled="this.isLoading"><b-icon icon="arrow-left"></b-icon></b-button>
          <label class="mx-2">{{year}} / {{monthNames[month]}}</label>
          <b-button @click="changeMonth('next')" size="sm" variant="primary" :disabled="this.isLoading"><b-icon icon="arrow-right"></b-icon></b-button>
          <b-button-group size="sm" class="ml-2">
            <b-button variant="primary" @click="changeStyle('monthly')" :disabled="this.isLoading">Monthly</b-button>
            <b-button variant="primary" @click="changeStyle('cards')" :disabled="this.isLoading">Cards</b-button>
          </b-button-group>
        </b-col>
      </b-row>
      <p v-if="!this.isLoading && this.events.length == 0 && this.style != 'monthly'">No records.</p>
      <b-spinner v-if="this.isLoading" variant="primary" label="Spinning"></b-spinner>
      <b-row v-if="!this.isLoading && this.events.length >= 0 && this.style == 'cards'">
        <b-col v-for="(event, index) in this.events" :key="index" cols="12" lg="3">
          <b-card>
            <b-card-text class="h3">
              Invoice # {{event.invoice_number}}
            </b-card-text>
            <b-card-text v-if="event.start_date != null && event.start_date.length > 0" class="mb-1">
              Start date: {{event.start_date}}
            </b-card-text>
            <b-card-text v-if="event.headstone_start_date != null" class="mt-1 mb-0">
              Headstone Start date: 
            </b-card-text>
            <b-card-text v-if="event.headstone_start_date != null" class="mt-0">
              {{event.headstone_start_date}}
            </b-card-text>
            <b-row align-v="end">
              <b-col cols="7">
                <b-button @click="showDetails(event)" size="sm" variant="primary">Show details</b-button>
              </b-col>
              <b-col cols="5">
                <b-row>
                  <b-col cols="12">
                    <b-badge variant="danger" v-if="event.isPending"> pending </b-badge>
                  </b-col>
                  <b-col cols="12">
                    <b-badge variant="danger" v-if="event.isOverdue"> overdue </b-badge>
                  </b-col>
                  <b-col cols="12">
                    <b-badge variant="warning" v-if="event.isRequestingForCompletion"> waiting </b-badge>
                  </b-col>
                  <b-col cols="12">
                    <b-badge v-if="event.isAccepted" :class="{'bg-success': event.status == 'active', 'bg-danger': event.status == 'overdue'}"> {{ event.status }} </b-badge>
                  </b-col>
                  <b-col cols="12">
                    <b-badge v-if="!event.isAccepted"> ready </b-badge>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
          <br>
        </b-col>
      </b-row>
      <b-row v-if="this.style == 'monthly' && !this.isLoading" class="monthly">
        <b-col cols="4" lg="2" v-for="(day, index) in this.months[month]" :key="index" class="day-grid">
          <p>{{day.day}}</p>
          <p class="worker-name" v-if="day.peters_events.length > 0">Peter's: </p>
          <div class="event" v-for="(event, i) in day.peters_events" :key="'Peters' + i">
            <div v-if="event.installation_staff.name == 'Peter'">
              <b-row align-v="center">
                <p class="event-name text-primary ml-4" @click="showDetails(event)" :class="{'text-primary': event.status == 'active', 'text-secondary': event.status == 'completed', 'text-warning': event.is_suspended == true}"> {{ event.invoice_number }} </p>
                <!-- <b-badge class="ml-1 event-badge" :class="{'bg-success': event.status == 'active', 'bg-danger': event.status == 'overdue'}" > {{ event.status }} </b-badge> -->
              </b-row>
            </div>
          </div>
          <p class="worker-name" v-if="day.johns_events.length > 0">John's: </p>
          <div class="event" v-for="(event, i) in day.johns_events" :key="'Johns' + i">
            <div v-if="event.installation_staff.name == 'John'">
              <b-row align-v="center">
                <p class="event-name text-primary ml-4" @click="showDetails(event)" :class="{'text-primary': event.status == 'active', 'text-secondary': event.status == 'completed', 'text-warning': event.is_suspended == true}"> {{ event.invoice_number }} </p>
                <!-- <b-badge class="ml-1 event-badge" :class="{'bg-success': event.status == 'active', 'bg-danger': event.status == 'overdue'}" > {{ event.status }} </b-badge> -->
              </b-row>
            </div>
          </div>
          <p class="worker-name" v-if="day.others_events.length > 0">Others': </p>
          <div class="event" v-for="(event, i) in day.others_events" :key="'Others' + i">
            <div>
              <b-row align-v="center">
                <p class="event-name text-primary ml-4" @click="showDetails(event)" :class="{'text-primary': event.status == 'active', 'text-secondary': event.status == 'completed', 'text-warning': event.is_suspended == true}"> {{ event.invoice_number }} </p>
                <!-- <b-badge class="ml-1 event-badge" :class="{'bg-success': event.status == 'active', 'bg-danger': event.status == 'overdue'}" > {{ event.status }} </b-badge> -->
              </b-row>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'EventCalendar',
  props: {
    user: Object
  },
  data() {
    return {
      maleMonth: [4, 6, 9, 11],
      isLoading: false,
      date: "",
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      year: 0,
      month: 0,
      yearMonth: "",
      events: [],
      style: "monthly",
      months: [],
    }
  },
  mounted() {
    this.yearMonth = this.year + '-' + String(this.month + 1).padStart(2, '0');
  },
  watch: {
    yearMonth(newYearMonth) {
      this.filterByYearMonth(newYearMonth);
    },
  },
  created() {
    this.initiateMonths();
    var today = new Date();
    this.month = today.getMonth();
    this.year = today.getFullYear();
  },
  methods: {
    changeMonth(mode) {
      //console.log(this.months);
      if (mode == "next") {
        if (this.month + 1 > 11) {
          this.month = (this.month + 1) % 12;
          this.year += 1;
        } else {
          this.month += 1;
        }
      } else if (mode == "prev") {
        if (this.month - 1 < 0) {
          this.month = 11;
          this.year -= 1;
        } else {
          this.month -= 1;
        }
      }

      this.yearMonth = this.year + '-' + String(this.month + 1).padStart(2, '0');
    },
    filterByYearMonth(yearMonth) {
      this.isLoading = true;
      var hasNewTypeOrder = false;
      const self = this;
      if(this.user.role == 'sales'&& this.user.name != 'Christine') {
        firebase.firestore().collection('events')
        .where("sales.id","==",this.user.id)
        .where("isPending","==",false)
        .where("start_year_month", "==", yearMonth)
        .orderBy("start_day", "asc")
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            this.initiateMonths();
            collection.docs.forEach(doc => {
              const index = doc.data().start_day;
              const event = doc.data();

              this.events.push(event);

              event.invoice_number += " ";
              event.invoice_number += event.cemetery;
              if (event.headstone_start_day != null && event.type == "installation") {
                event.invoice_number += " Ashlar";
                if(!hasNewTypeOrder) hasNewTypeOrder = true;
              }
              if (event.installation_staff.name == 'Peter') {
                self.months[self.month][index - 1].peters_events.push(event);
              } else if (event.installation_staff.name == 'John') {
                self.months[self.month][index - 1].johns_events.push(event);
                if (index == 28) {
                  console.log(self.months[self.month][index - 1].johns_events);
                }
              } else {
                self.months[self.month][index - 1].others_events.push(event);
              }
            })
          }
          if(!hasNewTypeOrder) self.isLoading = false;
        });

        firebase.firestore().collection('events')
        .where("sales.id","==",this.user.id)
        .where("isPending","==",false)
        .where("headstone_start_year_month", "==", yearMonth)
        .orderBy("headstone_start_day", "asc")
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            collection.docs.forEach(doc => {
              const index = doc.data().headstone_start_day;
              const event = doc.data();

              this.events.push(event);

              event.invoice_number += " ";
              event.invoice_number += event.cemetery;
              event.invoice_number += " Headstone";
              if (event.installation_staff.name == 'Peter') {
                self.months[self.month][index - 1].peters_events.push(event);
              } else if (event.installation_staff.name == 'John') {
                self.months[self.month][index - 1].johns_events.push(event);
                if (index == 28) {
                  console.log(self.months[self.month][index - 1].johns_events);
                }
              } else {
                self.months[self.month][index - 1].others_events.push(event);
              }
            })
          }
          if(hasNewTypeOrder) self.isLoading = false;
        });
      } else if (this.user.role == 'worker') {
        firebase.firestore().collection('events')
        .where("installation_staff.id","==",this.user.id)
        .where("isPending","==",false)
        .where("start_year_month", "==", yearMonth)
        .orderBy("start_day", "asc")
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            this.initiateMonths();
            collection.docs.forEach(doc => {
              const index = doc.data().start_day;
              const event = doc.data();

              this.events.push(event);

              event.invoice_number += " ";
              event.invoice_number += event.cemetery;
              if (event.headstone_start_day != null && event.type == "installation") {
                event.invoice_number += " Ashlar";
                if(!hasNewTypeOrder) hasNewTypeOrder = true;
              }
              if (event.installation_staff.name == 'Peter') {
                self.months[self.month][index - 1].peters_events.push(event);
              } else if (event.installation_staff.name == 'John') {
                self.months[self.month][index - 1].johns_events.push(event);
              } else {
                self.months[self.month][index - 1].others_events.push(event);
              }
            })
          }
          if(!hasNewTypeOrder) self.isLoading = false;
        });

        firebase.firestore().collection('events')
        .where("installation_staff.id","==",this.user.id)
        .where("isPending","==",false)
        .where("headstone_start_year_month", "==", yearMonth)
        .orderBy("headstone_start_day", "asc")
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            collection.docs.forEach(doc => {
              const index = doc.data().headstone_start_day;
              const event = doc.data();

              this.events.push(event);

              event.invoice_number += " ";
              event.invoice_number += event.cemetery;
              event.invoice_number += " Headstone";
              if (event.installation_staff.name == 'Peter') {
                self.months[self.month][index - 1].peters_events.push(event);
              } else if (event.installation_staff.name == 'John') {
                self.months[self.month][index - 1].johns_events.push(event);
              } else {
                self.months[self.month][index - 1].others_events.push(event);
              }
            })
          }
          if(hasNewTypeOrder) self.isLoading = false;
        });
      } else {
        this.events = [];
        firebase.firestore().collection('events')
        .where("start_year_month", "==", yearMonth)
        .orderBy("start_day", "asc")
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            this.initiateMonths();
            collection.docs.forEach(doc => {
              const index = doc.data().start_day;
              const event = doc.data();

              this.events.push(event);

              event.invoice_number += " ";
              event.invoice_number += event.cemetery;
              if (event.headstone_start_day != null && event.type == "installation") {
                event.invoice_number += " Ashlar";
                if(!hasNewTypeOrder) hasNewTypeOrder = true;
              }
              if (event.installation_staff.name == 'Peter') {
                self.months[self.month][index - 1].peters_events.push(event);
              } else if (event.installation_staff.name == 'John') {
                self.months[self.month][index - 1].johns_events.push(event);
              } else {
                self.months[self.month][index - 1].others_events.push(event);
              }
            })
          }
          if(!hasNewTypeOrder) self.isLoading = false;
        });

        firebase.firestore().collection('events')
        .where("headstone_start_year_month", "==", yearMonth)
        .orderBy("headstone_start_day", "asc")
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            collection.docs.forEach(doc => {
              const index = doc.data().headstone_start_day;
              const event = doc.data();

              this.events.push(event);

              event.invoice_number += " ";
              event.invoice_number += event.cemetery;
              event.invoice_number += " Headstone";
              if (event.installation_staff.name == 'Peter') {
                self.months[self.month][index - 1].peters_events.push(event);
              } else if (event.installation_staff.name == 'John') {
                self.months[self.month][index - 1].johns_events.push(event);
              } else {
                self.months[self.month][index - 1].others_events.push(event);
              }
            })
          }
          if(hasNewTypeOrder) self.isLoading = false;
        });
      }
    },
    showDetails(event) {
      this.$emit('showEventDetails', {event: event, from: 'Calendar'});
    },
    changeStyle(style) {
      this.style = style;
    },
    initiateMonths() {
      this.months = [];
      for (var i = 0; i < 12; i++) {
        var numberOfDays = 31;
        if (this.maleMonth.includes(i + 1)) {
          numberOfDays = 30;
        } else if (i + 1 == 2) {
          numberOfDays = 29;
        }
        var month = [];
        for (var c = 0; c < numberOfDays; c++) {
          month.push({day: c+1, 
            peters_events: [], 
            johns_events: [],
            others_events: []});
        }
        this.months.push(month);
      }
      //console.log(this.months);
    },
  },
}
</script>

<style>
.event-calendar {
  margin: 0;
}

.event-calendar .worker-name {
  margin: 0;
}

.event-calendar .day-grid {
  border: 1px solid #000;
  min-height: 100px;
}

.event-calendar .day-grid p{
  margin: 0;
}

.event-calendar .day-grid .event-name {
  display: inline;
  text-decoration: underline;
  cursor: pointer;
}

.event-calendar .day-grid .event-badge {
  margin: 0;
  display: inline;
}

.event-calendar .event-name {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.event-calendar .active {
  color: green;
}

.event-calendar .suspended {
  color: yellow;
}

.event-calendar .completed {
  color: gray;
}

.event-calendar .namebadege {
  margin: 0;
}
</style>